import PreferencesModalContainer from './containers/PreferencesModalContainer'

export default PreferencesModalContainer
